<template>
    <div class="History">
        <mt-header class="mtheader" style="position:relative;">
  <router-link to="/" slot="left">
    <mt-button icon="back"></mt-button>
  </router-link>
  <div slot="right" class="mtsearch">
      <form action="javascript:return true;">
      <input type="search" placeholder="案件号模糊搜索" v-model="searchValue" @keyup.13="search(searchValue)" ref="input1">
      </form>
      <div class="s-r-div" @click="search(searchValue)">
      <img class="search-icon" src="../assets/images/s-icon.png" width="10" height="10"/>
      </div>
      <div class="s-r-div" @click="cancelSearch()">
          <img src="../assets/images/clear-icon.png" width="10" height="10">
      </div>
    <!-- <mt-search v-model="searchValue" cancel-text="取消" placeholder="案件号模糊搜索" :result="filterResult"  @keyup.native.enter="search(searchValue)"></mt-search> -->
  </div>
  
</mt-header>
        <div class="nohistory" v-if="showStyle && caseList.length==0">
            <img src="../assets/images/his-icon.png" width="283" height="180">
            <p>{{no_text}}</p>
        </div>
        <div class="history-list" v-if="showStyle && caseList.length>0">
            <div class="order" v-for="(item,ind) in caseList" :key='ind'>
                    <div class="state-card" :class="borderColor(item['当前状态'])">
                        <div style="width:70%;text-align:left;">
                        <label>{{item["案件号"]}}</label>
                        </div>
                        <div class="state-text" :class="stateClass(item['当前状态'])">{{item["当前状态"]}}</div>
                    </div>
                <div class="o-detail">
                    <div v-for="(v,k,i) in item" :key="i" class="detail-cont">
                        <div class="o-d-left">
                            <p v-if="k!='当前状态' && k!='案件号' && k!='案件GUID'">{{k}}</p>
                        
                    </div>
                    <div class="o-d-right">
                            <p v-if="k!='当前状态' && k!='案件号' && k!='案件GUID'">{{v}}</p>
                    </div>
                    </div>
                </div>
                <mt-button class="o-btn" :class="btnClass(item['当前状态'])" size="normal" @click="toApplicate(ind)">{{btnText(item['当前状态'])}}</mt-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Indicator } from "mint-ui";

export default {
    name:'History',
    data(){
        return{
            caseNo:"",
            resdata:[],
            caseList:[],
            openid:"",
            searchValue:"",
            filterResult:[],
            showStyle:false,
            no_text:"您还没有申请记录哦！"
        }
    },
    created(){
        this.openid=window.localStorage.getItem('openid');
        Indicator.open({spinnerType: 'fading-circle'});
        this.getList();
    },
    mounted(){
        
    },
    computed:{
        
    },
    methods:{
        borderColor(state){
            switch(state){
                default:
                    return "border-grey";
                    break;
                case "已驳回":
                    return "border-red";
                    break;
                case "已审批":
                    return "border-green";
                    break;
            }
        },
        cancelSearch(){
            this.searchValue="";
            this.caseList=JSON.parse(JSON.stringify(this.resdata));
        },
        search(v){
            // Indicator.open({spinnerType: 'fading-circle'});
            this.caseList = JSON.parse(JSON.stringify(this.resdata));
            this.showStyle=false;
            var list = this.caseList;
            var arr=[];
            for(var i=0;i<list.length;i++){
                var item = list[i];
                if(item["案件号"].indexOf(v)!=-1){
                    arr.push(item);
                }
            }
            if(arr.length==0){
                this.no_text="搜索不到相关信息的案件！"
            }
            this.caseList=arr;
            // Indicator.close();
            this.showStyle=true;
            this.$refs.input1.blur();
        },
        btnText(state){
            switch(state){
                default:
                    return "查看";
                    break;
                case "已暂存":
                    return "去修改";
                    break;
                case "已审批":
                    return "去支付";
                    break;
                
            }
        },
        btnClass(state){
            switch(state){
                default:
                    return "b-blue";
                    break;
                case "已驳回":
                    return "b-red";
                    break;
                case "已审批":
                    return "b-green";
                    break;
            }
        },
        stateClass:(state)=>{
            switch(state){
                default:
                    return "s-grey";
                    break;
                case "已驳回":
                    return "s-red";
                    break;
                case "已审批":
                    return "s-green";
                    break;
            }
        },
        getList(){
    this.$Api.getHistory().then(res=>{
        this.showStyle=true;
        Indicator.close();
        var list=res.data;
            for(var i=0;i<list.length;i++){
                var item = list[i];
                    var time = item["创建时间"].replace(/T/g, ' ').replace(/.[\d]{3}Z/, ' ');
                    var creattime=time.slice(0,time.indexOf("."))
                    this.caseList.push({
                        "案件号":item["案件号"],
                        "案件GUID":item["案件GUID"],
                        "姓名":item["申请人姓名"]?item["申请人姓名"]:"待定",
                        "证件类型":item["申请人证件类型"]?item["申请人证件类型"]:"待定",
                        "证件号":item["申请人证件号"]?item["申请人证件号"]:"待定",
                        "手机号码":item["申请人联系电话"]?item["申请人联系电话"]:"待定",
                        "文件类型":item["翻译文件类型"]?item["翻译文件类型"]:"待定",
                        "原件语种":item["翻译件语种"]?item["翻译件语种"]:"待定",
                        "当前状态":item["当前状态"]?item["当前状态"]:"待定",
                        "案件时间":creattime,
                        "缴费金额":item["总价分"]?"￥ "+(Number(item["总价分"])/100).toFixed(2):"待定",
                    })
            }
            this.resdata=JSON.parse(JSON.stringify(this.caseList));
    });
        },
    //符合条件则跳转申请页面
    toApplicate(_ind){
        var state = this.caseList[_ind]["当前状态"];
        switch(state){
            default:
                this.$router.push("/Detail.html?caseguid="+this.caseList[_ind]["案件GUID"]);
            break;
            case "已暂存":
                this.$router.push("/Application.html?caseguid="+this.caseList[_ind]["案件GUID"]);
            break;
            
        }
    }
    }
}
</script>
<style lang="scss" scoped>
@import "../assets/css/my-mint.scss";

</style>

<style scoped>
.border-green{border-bottom: 0.5px solid #84D6AC;}
.border-red{border-bottom: 0.5px solid #FF0000;}
.border-grey{border-bottom: 0.5px solid #9EBAE1;}
.state-card{
    color: black;font-size: 13px;
    width: auto;
    left: 15px;
    position: absolute;
    right: 0;
    top: 0;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
}
.mtsearch{
    position:absolute;right:0;top:0;
    display: flex;
    justify-items: center;
    height: 30px;
    margin: 5px;
    background-color: white;
    border-radius: 6px;
    padding: 5px 0 5px 5px;
}
.mtsearch input{border: none;padding: 5px;border-radius: 5px;height: 100%;}
.s-r-div{width: 30px;border-right: 0.5px solid #B7B7B7;display: flex;justify-content: center;align-items: center;}
.detail-cont{
    display: flex;
    align-items: center;
}
.detail-cont p{margin-top: 0;}
.o-btn{
    width: 100%;
    color: white;
}
.state-text{
    width: 30%;
    border-radius: 0 10px 0 0;
    color: white;
    text-align: center;
    line-height: 40px;
    height: 40px;
}
.s-green{background-color: #84D6AC;}
.s-red{background-color: #FF0000;opacity: .5;}
.s-grey{background-color: #9EBAE1;}

.b-green{background-color: #09BB07;}
.b-red{background-color: #FF0000;}
.b-blue{background-color: #1E70E0;}
.nohistory{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 100px;
}
.nohistory p{
color: black;
font-size: 18px;
}
.order{ 
    background-color: white;
    margin-top: 10px;
    border-radius: 10px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, .1);
    padding: 15px;
    padding-top: 55px;
    position: relative;
}
/* .o-state{color: black;font-size: 13px;position: static;height: 40px;} */
.o-d-left{width: 20%;font-size: 13px;color: #666; text-align: right;}
.o-d-right{width: 75%;font-size: 13px;color:black;text-align: left;margin-left: 5%;}
</style>


// WEBPACK FOOTER //
// src/components/History.vue